import { gql } from "graphql-tag";
import {
  accountStudentInfoRequests,
  accountStudentInfoRequestsVariables,
  createStudentInfoRequest,
  createStudentInfoRequestVariables,
  deleteStudentInfoRequest,
  deleteStudentInfoRequestVariables,
  studentInfoRequest,
  studentInfoRequests,
  studentInfoRequestsVariables,
  studentInfoRequestVariables,
  updateStudentInfoRequest,
  updateStudentInfoRequestVariables,
} from "types/code-generator";
import { TypedDocumentNode } from "types/graphql";

export const StudentInfoRequestPayload = gql`
  fragment StudentInfoRequestPayload on StudentInfoRequest {
    answers
    availableForAllOfferings
    createdAt
    description
    department {
      id
      title
    }
    enabledByDefault
    id
    noQuestion
    order
    required
    singleResponse
    slug
    type
    yesQuestion
  }
`;

export const UpdateStudentInfoRequestMutation = gql`
  mutation updateStudentInfoRequest(
    $data: StudentInfoRequestCreateInput!
    $where: UniqueInput!
  ) {
    updateStudentInfoRequest(data: $data, where: $where) {
      ...StudentInfoRequestPayload
    }
  }
  ${StudentInfoRequestPayload}
` as TypedDocumentNode<
  updateStudentInfoRequest,
  updateStudentInfoRequestVariables
>;

export const DeleteStudentInfoRequestMutation = gql`
  mutation deleteStudentInfoRequest($id: String!) {
    deleteStudentInfoRequest(where: { id: $id }) {
      id
    }
  }
` as TypedDocumentNode<
  deleteStudentInfoRequest,
  deleteStudentInfoRequestVariables
>;

export const CreateStudentInfoRequestMutation = gql`
  mutation createStudentInfoRequest($data: StudentInfoRequestCreateInput!) {
    createStudentInfoRequest(data: $data) {
      ...StudentInfoRequestPayload
    }
  }
  ${StudentInfoRequestPayload}
` as TypedDocumentNode<
  createStudentInfoRequest,
  createStudentInfoRequestVariables
>;

export const StudentInfoRequestsQuery = gql`
  query studentInfoRequests($where: StudentInfoRequestWhereInput!) {
    studentInfoRequests(where: $where, orderBy: { order: asc }) {
      ...StudentInfoRequestPayload
    }
  }
  ${StudentInfoRequestPayload}
` as TypedDocumentNode<studentInfoRequests, studentInfoRequestsVariables>;

export const StudentInfoRequestQuery = gql`
  query studentInfoRequest($id: String!) {
    studentInfoRequest(where: { id: $id }) {
      ...StudentInfoRequestPayload
    }
  }
  ${StudentInfoRequestPayload}
` as TypedDocumentNode<studentInfoRequest, studentInfoRequestVariables>;

export const AccountStudentInfoRequestsQuery = gql`
  query accountStudentInfoRequests(
    $where: StudentInfoRequestWhereInput!
    $responseWhere: StudentInfoRequestResponseWhereInput
  ) {
    studentInfoRequests(where: $where, orderBy: { order: asc }) {
      ...StudentInfoRequestPayload
      studentInfoRequestResponses(where: $responseWhere) {
        id
        registration {
          id
          studentId
        }
      }
    }
  }
  ${StudentInfoRequestPayload}
` as TypedDocumentNode<
  accountStudentInfoRequests,
  accountStudentInfoRequestsVariables
>;
